import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateLifecycle } from '../../../../state';

const IsActiveEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateLifecycle({ isActive: event.target.checked }));
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={currentRecurringTask?.isActive ?? true}
          onChange={handleChange}
        />
      }
      label="Active"
    />
  );
};

export default IsActiveEdit;
